import * as React from "react";

import Box from "@mui/material/Box";

import PLSummary from "../pl-summary";

export default function PlReport() {
  return (
    <Box sx={{ paddingLeft: 2 }}>
      <PLSummary />
    </Box>
  );
}
